import { FC } from "react";

type ViewRemarksProps = {
  remarks: string;
};

const ViewRemarks: FC<ViewRemarksProps> = ({ remarks }) => {
  return (
    <div className="my-2">
      <div className="text-[#0A3690] font-bold">Remarks</div>
      <p className="text-[#A3B2CF]">{remarks}</p>
    </div>
  );
};

export default ViewRemarks;
